var map = {
	"./medal_elite.png": 1385,
	"./medal_first.png": 1386,
	"./medal_second.png": 1387,
	"./medal_third.png": 1388,
	"./medal_veteran.png": 1389
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2468;


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/RewardTooltip/images ^\.\/.*\.png$
// module id = 2468
// module chunks = 11